import styled from 'styled-components';

const NavigationRowExpandImg = styled.img`
  position: absolute;
  right: 20px;
  top: 20px;
  width: 10px;
`;

export default NavigationRowExpandImg;
